import { NextCategoryTileImg } from 'components/PreauthV3/NextCategoryTileImage';
import { CategoryTileProps } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTile';

const Bohemian = '/static-preauth/images/PaperLP/v3/ShopByStyle/Bohemian.jpg';
const Elegant = '/static-preauth/images/PaperLP/v3/ShopByStyle/Elegant.jpg';
const Floral = '/static-preauth/images/PaperLP/v3/ShopByStyle/Floral.jpg';
const Greenery = '/static-preauth/images/PaperLP/v3/ShopByStyle/Greenery.jpg';
const Modern = '/static-preauth/images/PaperLP/v3/ShopByStyle/Modern.jpg';
const Rustic = '/static-preauth/images/PaperLP/v3/ShopByStyle/Rustic.jpg';
const Simple = '/static-preauth/images/PaperLP/v3/ShopByStyle/Simple.jpg';
const Watercolor = '/static-preauth/images/PaperLP/v3/ShopByStyle/Watercolor.jpg';

const simpleTile: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Simple} alt="" square />,
  linkText: 'Simple',
  href: '/wedding-planning/suites/shop/simple_minimalist',
};

const floralTile: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Floral} alt="" square />,
  linkText: 'Floral',
  href: '/wedding-planning/suites/shop/floral',
};

const bohemianTile: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Bohemian} alt="" square />,
  linkText: 'Boho',
  href: '/wedding-planning/suites/shop/boho',
};

const modernTile: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Modern} alt="" square />,
  linkText: 'Modern',
  href: '/wedding-planning/suites/shop/modern',
};
const rusticTile: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Rustic} alt="" square />,
  linkText: 'Rustic',
  href: '/wedding-planning/suites/shop/rustic',
};
const elegantTile: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Elegant} alt="" square />,
  linkText: 'Elegant',
  href: '/wedding-planning/suites/shop/elegant_formal',
};
const greeneryTile: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Greenery} alt="" square />,
  linkText: 'Greenery',
  href: '/wedding-planning/suites/shop/greenery',
};
const waterColorTile: CategoryTileProps = {
  altText: '',
  imageElement: <NextCategoryTileImg image={Watercolor} alt="" square />,
  linkText: 'Watercolor',
  href: '/wedding-planning/suites/shop/watercolor',
};

export const shopByStyleTiles = [
  simpleTile,
  floralTile,
  bohemianTile,
  modernTile,
  rusticTile,
  elegantTile,
  greeneryTile,
  waterColorTile,
];
